import { useCallback, useMemo } from "react";
import { useSwimmersResource } from "../../../swimmers/hooks/useSwimmersResource";
import { useGetSwimmersCount } from "../../../swimmers/services/swimmerService";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes/routes";
import { useAuthStore } from "../../../../store";
import type { Swimmer } from "../../../../api/client/types/swimmer.types";

export const useSwimmersTab = () => {
  const swimmersResource = useSwimmersResource();
  const { user } = useAuthStore();
  const buildingId = user?.buildingId;
  const lifeguardId = user?.id;

  const navigate = useNavigate();

  const handleOnRegisterSwimmer = () => {
    navigate(ROUTES.SWIMMERS.REGISTER);
  };

  const handleEditSwimmer = useCallback(
    (swimmer: Swimmer) => {
      navigate(ROUTES.SWIMMERS.EDIT_LIFEGUARD(swimmer.id));
    },
    [navigate]
  );

  // Get today's date in DD/MM/YYYY format (Colombian timezone)
  const todayDateStr = useMemo(() => {
    const now = new Date();
    const colombiaDateStr = now.toLocaleDateString("en-CA", {
      timeZone: "America/Bogota",
    }); // Returns YYYY-MM-DD format
    const [year, month, day] = colombiaDateStr.split("-");
    
    // Convert to DD/MM/YYYY format for the API
    return `${day}/${month}/${year}`;
  }, []);

  // Fetch today's swimmers count using the count endpoint
  const { data: todayCountData } = useGetSwimmersCount({
    building_id: buildingId || undefined,
    lifeguard_id: lifeguardId || undefined,
    start_date: todayDateStr,
    end_date: todayDateStr,
  });

  const todayCount = todayCountData?.count ?? 0;

  return {
    swimmersResource,
    handleOnRegisterSwimmer,
    handleEditSwimmer,
    todayCount,
  };
};
